// Tiny HTML helpers. Every interpolated value goes through esc() unless it is
// already markup produced by these helpers.

const ESC = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
export const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ESC[c]);

export const attrs = (obj) =>
  Object.entries(obj)
    .filter(([, v]) => v !== false && v != null)
    .map(([k, v]) => (v === true ? k : `${k}="${esc(v)}"`))
    .join(" ");

export const options = (list, selected, placeholder) =>
  (placeholder ? `<option value="">${esc(placeholder)}</option>` : "") +
  list.map((o) => `<option ${attrs({ value: o.id, selected: String(o.id) === String(selected ?? "") })}>${esc(o.label)}</option>`).join("");

export const usd = (x) =>
  x == null ? "TBD" : x.toLocaleString("en-US", { style: "currency", currency: "USD" });

export const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;
